module.exports = __webpack_public_path__ + "img/electric-mining-drill-S.57927b0c.png";